import { NO_VALUE_RESPONSE } from '@constants';

export const getValidPoints = <T>(data: T[], key1: keyof T, key2: keyof T): T[] => {
  return data.filter(
    (item) =>
      item[key1] !== null &&
      item[key1] !== undefined &&
      item[key1] !== NO_VALUE_RESPONSE &&
      item[key2] !== null &&
      item[key2] !== undefined &&
      item[key2] !== NO_VALUE_RESPONSE,
  );
};
